import { all, call, fork, put } from 'redux-saga/effects';

import { getPathName } from 'utils/utils';
import { PREVIEW } from 'constants/Parameters';
import { putAndWait } from 'modules/app/sagas';
import { UNFETCHABLE_PATHS } from 'constants/Routes';
import { simpleRequestsLoader } from 'modules/app/utils';

import { formatEntity } from '../utils';
import { FETCH_ENTITY, SEND_RATING } from '../actionTypes';
import { fetchEntity, fetchEntitySuccess, readEntity } from '../actions';

import signatureModalSagas, { checkPendingSignatureModalOnLoad, watchSignatureModalTrigger } from './signatureModal';

const requestsConfig = {
  [FETCH_ENTITY]: {
    callbacks: {
      success: (payload, meta) => fetchEntitySuccess(formatEntity(undefined, payload), meta),
    },
  },
  [SEND_RATING]: {
    notifications: {
      success: { id: 'web.rating.success', defaultMessage: 'Feedback sent' },
      failure: { id: 'web.rating.error', defaultMessage: 'Can’t send your feedback' },
    },
  },
};

function* startApp() {
  if (!UNFETCHABLE_PATHS.includes(getPathName())) {
    const { payload } = yield putAndWait(fetchEntity());
    if (payload.redirectUrl) {
      window.location.replace(payload.redirectUrl);
      return;
    }
    if (!PREVIEW && payload.readUrl) {
      yield put(readEntity(payload.readUrl, { '@app-request': true, silent: true }));
    }

    yield call(checkPendingSignatureModalOnLoad, payload.id);
    yield fork(watchSignatureModalTrigger);
  }
}

export default function* saga() {
  yield fork(startApp);
  yield fork(signatureModalSagas);
  yield all(simpleRequestsLoader(requestsConfig));
}
